export const readCookie = (name: string) => {
  return (document?.cookie.match('(^|;) *' + name + '=([^;]*)') || [])[2];
};

export const removeCookie = () => {
  const cookies = document.cookie.split(';');
  cookies.forEach(c => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires${new Date().toUTCString()};path=/`);
  });
};
